import {
  cloneCalendar,
  cloneDay,
  fillGaps,
  indexForDate,
} from './functions';
import { window, average } from '../../lib/functions';

export const mergeCalendar = (cal, data) => {
  if (!data.length) {
    return cal;
  }
  const calendar = cal;
  const index = indexForDate(data[0].date, calendar);
  const target = index + data.length;
  let y = 0;
  for (let i = index; i < target; i += 1) {
    calendar[i] = data[y];
    y += 1;
  }
  return calendar;
};

const doAcrCalcs = (calendar, load, acrKey) => {
  const chronicLoad = calendar
    .reduce(window(28), [])
    .map(w => (w === null ? null : w.map(load).reduce(average)));
  const acuteLoad = calendar
    .reduce(window(7), [])
    .map(w => (w === null ? null : w.map(load).reduce(average)));

  return calendar.map((d, index) => {
    if (chronicLoad[index] !== null && acuteLoad[index] !== null) {
      const day = d;
      day[acrKey] = chronicLoad[index] === 0
        ? 0
        : acuteLoad[index] / chronicLoad[index];
      return day;
    }
    return d;
  });
};

export const calculateAcrRange = (date, includeWorkouts, calendarCopy) => {
  const weightedLoad = d => (
    includeWorkouts ? ((d.weightedLoad || 0) + (d.plannedWeightedLoad || 0)) : (d.weightedLoad || 0)
  );
  const vbLoad = d => (
    includeWorkouts ? ((d.distance || 0) + (d.plannedDistance || 0)) : (d.distance || 0)
  );
  const acrKey = includeWorkouts ? 'ebAcrPw' : 'ebAcr';
  const vbAcrKey = includeWorkouts ? 'vbAcrPw' : 'vbAcr';
  let calendar = cloneCalendar(
    calendarCopy
      .filter(d => d.date.isSameOrAfter(
        date.clone().subtract(28, 'days'),
        null,
        '[]',
      )),
  );

  const max = date.clone().add(28, 'days');
  if (!calendar.find(d => d.date.isSame(max, 'day'))) {
    const clone = cloneDay(calendar[0]);
    clone.date = max.clone();
    calendar.push(clone);
  }
  calendar = fillGaps(
    calendar,
    calendar[0].date,
    calendar[calendar.length - 1].date,
  );

  calendar = doAcrCalcs(calendar, weightedLoad, acrKey);
  calendar = doAcrCalcs(calendar, vbLoad, vbAcrKey);

  return calendar;
};

export const getters = {
  estimateAcr: (state, getter) => (day, value, type, calendar) => {
    if (!day.isValid()) {
      console.error('Invalid date passed to estimateAcr');
      return 0;
    }
    const key = type === 'vbl' ? 'plannedDistance' : 'plannedWeightedLoad';
    const loadTypeKey = type === 'vbl' ? 'distance' : 'weightedLoad';
    const period = 28;
    const start = day.clone().subtract(period, 'days').startOf('day');
    const end = day.clone().endOf('day');
    let range = (calendar || getter.calendar)
      .filter(i => i.date.isBetween(start, end))
      .map(d => ({
        date: d.date.clone(),
        weightedLoad: d.weightedLoad,
        distance: d.distance,
        [key]: d[key],
      }));

    if (range.length !== period) {
      const d = range.find(i => i.date.isSame(day));
      if (!d) {
        const clone = cloneDay(range[0]);
        clone.date = day.clone();
        clone[key] = value;
        clone.weightedLoad = 0;
        clone.distance = 0;
        range.push(clone);
      }
      range = fillGaps(range, start, end);
    } else {
      range.find(d => d.date.isSame(day, 'day'))[key] = value;
    }

    const chronicLoad = Math.round(
      range.reduce((t, i) => t + i[loadTypeKey] + (i[key] || 0), 0) / range.length,
    );
    const acuteLoad = Math.round(
      range.slice(range.length - 7)
        .reduce((t, i) => t + i[loadTypeKey] + (i[key] || 0), 0) / 7,
    );

    return acuteLoad / chronicLoad;
  },
};

export const actions = {
  recalculateAcr(context, { date, includeWorkouts = false }) {
    const calendar = calculateAcrRange(date, includeWorkouts, context.getters.calendarCopy);
    context.commit('updateCalendar', calendar);
  },
};
